// import React, { useRef, useState, useEffect } from 'react';
import React from 'react';
import { usePrevious, useWindowScroll } from 'react-use';
import Link from 'next/link';
import cn from 'classnames';

import styles from './navigation.module.css';

const Navigation = ({
  theme,
  title,
  links,
  children,
  href,
  blur,
  sticky,
  initialBackground,
  animate
}) => {
  const offset = 198; // header and navigation offset
  const { y } = useWindowScroll();
  const prevY = usePrevious(y);
  const direction = y > prevY ? 'forwards' : 'backwards';
  const className = y > offset ? direction : '';

  // this works in the case the page is loaded at the top but since the position is sticky it calculates the wrong offset if loaded in any other position, need to fix.
  // const ref = useRef({ offsetTop: 0, offsetHeight: 0 });
  // const [offset, setOffset] = useState(0);
  // useEffect(() => {
  //   setOffset(ref.current.offsetTop + ref.current.offsetHeight);
  // }, []);

  const resolvedTheme = {
    dark: {
      background: 'rgba(0,0,0,.8)',
      color: 'text-white'
    },
    light: {
      background: 'rgba(255,255,255,.8)',
      color: 'text-black'
    }
  };

  const navStyle = {
    background:
      initialBackground && y < offset ? initialBackground : resolvedTheme[theme].background,
    WebkitBackdropFilter: initialBackground && y < offset ? '' : `saturate(80%) blur(${blur}px)`,
    backdropFilter: initialBackground && y < offset ? '' : `saturate(180%) blur(${blur}px)`
  };

  return (
    <div
      className={cn(
        navStyle.background,
        {
          [styles.navigation]: animate,
          [styles[className]]: animate,
          'pb-0': y < offset && animate
        },
        'py-4 top-0 z-30 hidden lg:block user-select-none',
        { sticky, relative: !sticky }
      )}
      style={sticky ? navStyle : null}
      // ref={ref}
    >
      <div className="container">
        <nav className="flex items-center justify-between">
          {title && (
            <>
              {title.href || href ? (
                <Link href={title.href || href}>
                  <a
                    className={`text-sm font-medium ${resolvedTheme[theme].color}  uppercase tracking-widest`}
                  >
                    {title.text || title}
                  </a>
                </Link>
              ) : (
                <span
                  className={`text-sm font-medium ${resolvedTheme[theme].color} uppercase tracking-widest`}
                >
                  {title.text || title}
                </span>
              )}
            </>
          )}
          {links && (
            <ul className="flex items-center">
              {links.map(link => (
                <li className="ml-14" key={`${link.text}`}>
                  <a
                    className={`text-sm font-normal block ${resolvedTheme[theme].color} hover:opacity-80 transition-all duration-500`}
                    href={link.href}
                  >
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          )}
          {children}
        </nav>
      </div>
    </div>
  );
};

Navigation.defaultProps = {
  initialBackground: 'transparent',
  theme: 'dark',
  blur: '20',
  sticky: true,
  animate: true
};

export default Navigation;
